import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import useInquiries from './hooks/useInquiries';
import InquiryItem from './InquiryItem';

function InquiryLogs() {
    const { inquiries, fetchNextPage, isFetching } = useInquiries();
    return (
        <Container spacing={18}
            fullWidth
            align='center'>
            {inquiries?.map((inquiry) => (
                <InquiryItem key={inquiry.inquiryId} inquiry={inquiry} />
            ))}
            {isFetching && (<Loading size='small'/>)}
            <InfinityScrollTrigger trigger={fetchNextPage} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px;
`;

export default InquiryLogs;
